import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { useChartData } from '../../context/ChartContext';
import useSpectrum from '../../hooks/useSpectrum';
import { zoneStateInit } from '../../reducer/Reducer';
import Zone from './Zone';
function ZonesInner({ zones, display, displayerKey, isVisible, }) {
    return (_jsx("g", { clipPath: `url(#${displayerKey}clip-chart-2d)`, className: "2D-Zones", children: display.isVisible &&
            zones.values.map((zone) => (_jsx("g", { className: "zone", children: _jsx(Zone, { zoneData: zone, isVisible: isVisible }) }, zone.id))) }));
}
const MemoizedZones = memo(ZonesInner);
const emptyData = { zones: {}, display: {} };
export default function Zones() {
    const { displayerKey, view: { zones: zoneState }, } = useChartData();
    const { zones, display, id } = useSpectrum(emptyData);
    const isVisible = useMemo(() => {
        const { showPeaks, showSignals, showZones } = zoneState.find((r) => r.spectrumID === id) || zoneStateInit;
        return {
            zones: showZones,
            signals: showSignals,
            peaks: showPeaks,
        };
    }, [id, zoneState]);
    return _jsx(MemoizedZones, { zones, display, displayerKey, isVisible });
}
